import { voidfallChapters } from './content';
export const voidfallFaq = voidfallChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('FAQ'));
